// Menu alternatives are OR; an alternative may itself require all of its keys.
export function hasMenuPermission(required, has) {
  if (!required) return true;
  return (Array.isArray(required) ? required : [required]).some(keys => has(keys));
}
